"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const fonts_1 = __importDefault(require("../../fonts/fonts"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledContainer = styled_components_1.default.div `
  display: flex;
`;
const StyledGaugeContainer = styled_components_1.default.div `
  position: relative;
`;
const StyledGauge = styled_components_1.default.div `
  padding-top: 3px;
  .orange {
    background-color: ${tokens.ColorFunctionalOrange300};
    width: 38px;
    height: 16px;
    display: inline-block;
  }
  .gold {
    background-color: ${tokens.ColorFunctionalGold300};
    width: 5px;
    height: 16px;
    display: inline-block;
  }
  .green {
    background-color: ${tokens.ColorFunctionalGreen300};
    width: 12px;
    height: 16px;
    display: inline-block;
  }
`;
const StyledConfidenceNumber = styled_components_1.default.div `
  font-family: Nimbus Sans Bold;
  font-size: ${props => props.mobileFontSize || "24px"};
  color: ${props => props.fontColor || tokens.ColorWhite000};
  margin-left: 16px;
`;
const StyledPointer = styled_components_1.default.div `
  border-width: 1.5px;
  border-style: solid;
  border-color: ${props => props.markerColor || tokens.ColorWhite000};
  background-color: ${props => props.markerColor || "transparent"};
  height: 22px;
  position: absolute;
  left: ${props => (props.confidenceNumber / 100) * 56 + "px"};
`;
class ConfidenceNumberGaugeMobile extends react_1.Component {
    render() {
        const { confidenceNumber, markerColor, fontColor, mobileFontSize } = this.props;
        return (react_1.default.createElement(StyledContainer, null,
            react_1.default.createElement(fonts_1.default, null),
            react_1.default.createElement(StyledGaugeContainer, null,
                react_1.default.createElement(StyledPointer, { confidenceNumber: confidenceNumber, markerColor: markerColor }),
                react_1.default.createElement(StyledGauge, null,
                    react_1.default.createElement("div", { className: "orange" }),
                    react_1.default.createElement("div", { className: "gold" }),
                    react_1.default.createElement("div", { className: "green" }))),
            react_1.default.createElement(StyledConfidenceNumber, { fontColor: fontColor, mobileFontSize: mobileFontSize }, confidenceNumber + "%")));
    }
}
exports.default = ConfidenceNumberGaugeMobile;
//# sourceMappingURL=ConfidenceNumberGaugeMobile.js.map